module.exports = __webpack_public_path__ + "img/인덕원 미용실 3.80a6cfa0.png";